import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, Planzone, PlanzoneSettings } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  settings: PlanzoneSettings;
  retrievePlanzoneSettings(
    credentials: Boundaries["retrievePlanzoneSettings"]["request"],
  ): void;
}

function useRetrievePlanzoneSettings(
  planzone: Identifiable<Planzone>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrievePlanzoneSettingsRequestPending(planzone),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrievePlanzoneSettingsRequestSuccess(planzone),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrievePlanzoneSettingsRequestFailure(planzone),
    ),
    settings: useSelector(() => selector.getPlanzoneSettings(planzone)),
    retrievePlanzoneSettings: core.retrievePlanzoneSettings,
  };
}

export { useRetrievePlanzoneSettings };
